export const faqList = [
  {
    id: "faq-1",
    question: "瓜田爆料的可信度评分是怎么算出来的？",
    answer:
      "我们按源头可查性、证据链完整度、多方交叉印证、官方回应情况四个维度分别打分，再按权重合成 0-100 的可信度分数，并对应四个结论标签：实锤、存疑、待定、辟谣。评分只针对证据，不针对任何人。",
    group: "鉴定标准",
  },
  {
    id: "faq-2",
    question: "“实锤”“存疑”“待定”“辟谣”分别代表什么？",
    answer:
      "实锤指存在可独立核验的硬证据且多方印证；存疑指证据倾向成立但关键环节仍依赖单一来源；待定指线索零散、来源等级偏低；辟谣指出现明确官方回应或硬反证，传闻不成立或被误读。",
    group: "鉴定标准",
  },
  {
    id: "faq-3",
    question: "为什么有些爆料分数不高，却依然被收录？",
    answer:
      "收录不代表认可。低分条目同样有价值——它能告诉你这条传闻目前缺什么，避免你只看到被反复转发的那一面。我们会在条目里明确标出待确认环节。",
    group: "鉴定标准",
  },
  {
    id: "faq-4",
    question: "“同款”“同城”“互关”这类线索你们怎么判断？",
    answer:
      "这类属于弱证据。我们会先检查是否存在更合理的解释，例如剧组共用造型、剧宣集中行程、常规社交行为。相关性不等于因果，缺少闭环时通常只能给到存疑或待定。",
    group: "鉴定标准",
  },
  {
    id: "faq-5",
    question: "我可以向瓜田爆料投稿线索吗？",
    answer:
      "可以。请通过联系我们页面的投稿表单提交，尽量附上可核验的原始材料与时间信息。对于缺少基本要素的碎片化描述，我们通常无法进入鉴定流程。",
    group: "投稿合作",
  },
  {
    id: "faq-6",
    question: "投稿之后一般多久会有结果？",
    answer:
      "线索受理后我们会做初步筛查，材料完整的条目通常在三到五个工作日内完成第一轮评估；需要多方核实的复杂条目会更久，我们会通过你留下的联系方式同步进度。",
    group: "投稿合作",
  },
  {
    id: "faq-7",
    question: "如果我发现你们的鉴定结论有误怎么办？",
    answer:
      "欢迎纠错。请在联系表单中选择纠错反馈，并附上可核验的反证材料。核实后我们会公开更新结论，并在条目中标注修改时间与修改说明，不做静默修改。",
    group: "投稿合作",
  },
  {
    id: "faq-8",
    question: "你们会公开爆料的来源和原始材料吗？",
    answer:
      "会公开来源类型与可核验程度，例如公开记录、官方物料、当事人陈述等。涉及个人隐私、联系方式或可能造成二次伤害的材料，我们只描述可核验要点，不做原样传播。",
    group: "内容边界",
  },
  {
    id: "faq-9",
    question: "鉴定会不会涉及个人隐私？",
    answer:
      "我们划定了隐私红线。婚姻登记、医疗信息、家庭住址、未成年相关信息等一律不进入鉴定与传播范围，即使相关材料存在，也不会作为评分依据。",
    group: "内容边界",
  },
  {
    id: "faq-10",
    question: "为什么有些条目后来被更新了结论？",
    answer:
      "爆料是动态的。出现新的可核验材料、官方回应或有效反证时，我们会重新评估并公开更新，同时在条目中保留历史结论与修改记录，方便读者对照。",
    group: "内容边界",
  },
];